import { isDeviceMobile } from "../../../../libs/auth.helper";
import { redirectToEditPost, redirectToOpenSooq } from "../../../../utils/chat.utils";
export var SystemMessageTypes;
(function (SystemMessageTypes) {
    SystemMessageTypes["ADD_BOOKMARK"] = "50.500";
    SystemMessageTypes["POST_CALL"] = "50.501";
    SystemMessageTypes["ASK_FOR_PRICE"] = "50.502";
    SystemMessageTypes["ASK_FOR_DROP_PRICE"] = "50.503";
    SystemMessageTypes["ASK_FOR_IMAGE"] = "50.504";
    SystemMessageTypes["ASK_FOR_MAP"] = "50.506";
    SystemMessageTypes["APPLY_TO_JOB"] = "50.508";
    SystemMessageTypes["SIMILAR_ADS"] = "30.303";
    SystemMessageTypes["ASK_FOR_VIN"] = "50.505";
    SystemMessageTypes["MESSAGE_SMS"] = "50.509";
    SystemMessageTypes["MESSAGE_WHATSAPP"] = "50.510";
    SystemMessageTypes["ASK_FOR_VIDEO"] = "50.511";
    SystemMessageTypes["ASK_FOR_PRICE_S2B"] = "50.552";
    SystemMessageTypes["ASK_FOR_DROP_PRICE_S2B"] = "50.553";
    SystemMessageTypes["ASK_FOR_IMAGE_S2B"] = "50.554";
    SystemMessageTypes["ASK_FOR_VIN_S2B"] = "50.555";
    SystemMessageTypes["ASK_FOR_LOCATION_S2B"] = "50.556";
    SystemMessageTypes["ASK_FOR_VIDEO_S2B"] = "50.561";
})(SystemMessageTypes || (SystemMessageTypes = {}));
export const SystemMessages = {
    [SystemMessageTypes.SIMILAR_ADS]: {
        type: 30,
        subType: 303,
        text: (lang, _username, _isSender) => {
            return lang === 'en' ? "I’m interested" : "أنا مهتم";
        },
        slug: "similar_ads",
        hasButtonSeller: false,
        hasButtonBuyer: false,
        buttonTextSeller: '',
        buttonTextBuyer: '',
    },
    [SystemMessageTypes.ADD_BOOKMARK]: {
        type: 50,
        subType: 500,
        text: (lang, _username, _isSender) => {
            return lang === "en" ? "I’ve added this listing to my favorites" : "أضفت الإعلان لقائمة الإعلانات المفضلة";
        },
        rich: { icon: "/stickers/fav.png" },
        slug: "add_bookmark",
        hasButtonSeller: false,
        hasButtonBuyer: false,
        buttonTextSeller: '',
        buttonTextBuyer: '',
    },
    [SystemMessageTypes.POST_CALL]: {
        type: 50,
        subType: 501,
        text: (lang, _username, _isSender) => {
            return lang === 'en' ? "I checked the seller’s phone number" : "قُمتَ بإظهار رقم البائع";
        },
        rich: { icon: "/stickers/call.png" },
        slug: "post_call",
        hasButtonSeller: false,
        hasButtonBuyer: false,
        buttonTextSeller: '',
        buttonTextBuyer: '',
    },
    [SystemMessageTypes.ASK_FOR_PRICE]: {
        type: 50,
        subType: 502,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? "I want to be notified if a price is added to this listing" : `${username} want to be notified if a price is added to this listing`;
                case 'ar':
                    return isSender ? "أريد أن اتلقى تنبيها اذا تم تحديد سعر لهذا الإعلان" : 'أن يتلقى تنبيها اذا تم تحديد سعر لهذا الإعلان ' + "\u200E" + username + "\u200E" + 'يريد';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForPrice.png",
        },
        slug: "ask_for_price",
        hasButtonSeller: true,
        hasButtonBuyer: false,
        buttonTextSeller: 'ASK_FOR_PRICE',
        buttonTextBuyer: '',
        action: (message) => {
            const identifier = isDeviceMobile() ? 'price_field' : 'priceStepLabelIdentifier';
            redirectToEditPost(identifier, message.pid);
        }
    },
    [SystemMessageTypes.ASK_FOR_DROP_PRICE]: {
        type: 50,
        subType: 503,
        text: (lang, _username, _isSender) => {
            return lang === 'en' ? "I want to be notified if the price drops on this listing" : "أريد أن اتلقى تنبيها اذا تم تخفيض سعر هذا الإعلان";
        },
        rich: {
            icon: "/stickers/askForPrice.png",
        },
        slug: "ask_for_drop_price",
        hasButtonSeller: true,
        hasButtonBuyer: false,
        buttonTextSeller: 'ASK_FOR_DROP_PRICE',
        buttonTextBuyer: '',
        action: (message) => {
            const identifier = isDeviceMobile() ? 'price_field' : 'priceStepLabelIdentifier';
            redirectToEditPost(identifier, message.pid);
        }
    },
    [SystemMessageTypes.ASK_FOR_IMAGE]: {
        type: 50,
        subType: 504,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? "I want to be notified when images are added to this listing" : `${username} want to be notified when images are added to this listing`;
                case "ar":
                    return isSender ? "أريد أن اتلقى تنبيها اذا تمت إضافة صور لهذا الإعلان" : "أن يتلقى تنبيها اذا تمت إضافة صور لهذا الإعلان " + "\u200E" + username + "\u200E" + 'يريد';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForImageChat.png",
        },
        slug: "ask_for_image",
        hasButtonSeller: true,
        hasButtonBuyer: false,
        buttonTextSeller: 'ASK_FOR_IMAGE',
        buttonTextBuyer: '',
        action: (message) => {
            const identifier = isDeviceMobile() ? 'postMedia' : 'mediaStepIdentifier';
            redirectToEditPost(identifier, message.pid);
        }
    },
    [SystemMessageTypes.ASK_FOR_VIN]: {
        type: 50,
        subType: 505,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? 'VIN Number request has been sent' : `${username} has requested to add VIN Number`;
                case 'ar':
                    return isSender ? 'تم إرسال طلب إضافة رقم الشاصي' : 'بإرسال طلب رقم الشاصي ' + "\u200E" + username + "\u200E" + ' قام';
            }
            return '';
        },
        slug: "add_vin_number",
        hasButtonSeller: true,
        hasButtonBuyer: false,
        buttonTextSeller: 'ADD_VIN_NUMBER',
        buttonTextBuyer: '',
        action: (message) => {
            const identifier = isDeviceMobile() ? 'vinNumber_fieldLabel' : 'vinNumber_field';
            redirectToEditPost(identifier, message.pid);
        }
    },
    [SystemMessageTypes.ASK_FOR_MAP]: {
        type: 50,
        subType: 506,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? "I want to be notified if a map is added to this listing" : `${username} want to be notified if a map is added to this listing`;
                case "ar":
                    return isSender ? "أريد أن اتلقى تنبيها اذا تم تحديد الخريطة لهذا الإعلان" : "أن يتلقى تنبيها اذا تم تحديد الخريطة لهذا الإعلان  " + "\u200E" + username + "\u200E" + 'يريد';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForMap.png",
        },
        slug: "ask_for_map",
        hasButtonSeller: true,
        hasButtonBuyer: false,
        buttonTextSeller: 'ASK_FOR_MAP',
        buttonTextBuyer: '',
        action: (message) => {
            const identifier = isDeviceMobile() ? 'locationStepLabelIdentifier' : 'locationSectionIdentifier';
            redirectToEditPost(identifier, message.pid);
        }
    },
    [SystemMessageTypes.APPLY_TO_JOB]: {
        type: 50,
        subType: 508,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? "You have applied to this job" : `${username} has applied to your job opening`;
                case "ar":
                    return isSender ? "تم التقديم على الوظيفة" : "قام بالتقديم على الوظيفة " + "\u200E" + username + "\u200E";
            }
            return '';
        },
        rich: {
            icon: "/stickers/applyToJob.png",
        },
        slug: "apply_to_job",
        hasButtonSeller: false,
        hasButtonBuyer: false,
        buttonTextSeller: 'APPLY_TO_JOB',
        buttonTextBuyer: '',
        action: (message) => {
            console.log('Check CV!'); //TO-DO
        }
    },
    [SystemMessageTypes.MESSAGE_SMS]: {
        type: 50,
        subType: 509,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? "You tried to contact the seller using SMS" : `${username} tried to contact you using SMS`;
                case 'ar':
                    return isSender ? "قُمتَ بمحاولة التواصل مع البائع عبر رسالة نصيّة" : 'بمحاولة التواصل معك عبر رسالة نصيّة ' + "\u200E" + username + "\u200E" + ' قام';
            }
            return '';
        },
        slug: "message_sms",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.MESSAGE_WHATSAPP]: {
        type: 50,
        subType: 510,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? "You tried to contact the seller using WhatsApp" : `${username} tried to contact you using WhatsApp`;
                case 'ar':
                    return isSender ? "قُمتَ بمحاولة التواصل مع البائع عبر الواتساب" : 'بمحاولة التواصل معك عبر الواتساب ' + "\u200E" + username + "\u200E" + ' قام';
            }
            return '';
        },
        slug: "message_whatsapp",
        hasButtonSender: false,
        hasButtonReceiver: false,
        buttonText_sender_id: '',
        buttonText_receiver_id: '',
    },
    [SystemMessageTypes.ASK_FOR_PRICE_S2B]: {
        type: 50,
        subType: 552,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? `I've added a price to this listing` : 'A price was added to this listing';
                case 'ar':
                    return isSender ? 'تم تحديد سعر لهذا الإعلان' : 'تم تحديد سعر لهذا الإعلان';
            }
            return '';
        },
        slug: "ask_for_price_s2b",
        hasButtonSeller: false,
        hasButtonBuyer: true,
        buttonTextSeller: '',
        buttonTextBuyer: 'ASK_FOR_PRICE_S2B_BUYER',
        action: (message) => {
            redirectToOpenSooq(message.pid);
        },
    },
    [SystemMessageTypes.ASK_FOR_DROP_PRICE_S2B]: {
        type: 50,
        subType: 553,
        text: (lang, _username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? `I've lowered the price of this listing` : 'The price of this listing has dropped';
                case 'ar':
                    return isSender ? 'تم تخفيض سعر هذا الإعلان' : 'تم تخفيض سعر هذا الإعلان';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForPrice.png",
        },
        slug: "ask_for_drop_price_s2b",
        hasButtonSeller: false,
        hasButtonBuyer: true,
        buttonTextSeller: '',
        buttonTextBuyer: 'ASK_FOR_DROP_PRICE_S2B',
        action: (message) => {
            redirectToOpenSooq(message.pid);
        },
    },
    [SystemMessageTypes.ASK_FOR_IMAGE_S2B]: {
        type: 50,
        subType: 554,
        text: (lang, _username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? `I've added images to this listing` : 'Images have been added to this listing';
                case 'ar':
                    return isSender ? 'تمت إضافة صور لهذا الإعلان' : 'تمت إضافة صور لهذا الإعلان';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForVIN.png",
        },
        slug: "ask_for_image_s2b",
        hasButtonSeller: false,
        hasButtonBuyer: true,
        buttonTextSeller: '',
        buttonTextBuyer: 'ASK_FOR_IMAGE_S2B',
        action: (message) => {
            redirectToOpenSooq(message.pid);
        },
    },
    [SystemMessageTypes.ASK_FOR_VIN_S2B]: {
        type: 50,
        subType: 555,
        text: (lang, _username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? `I've added the VIN number to this listing` : 'The VIN has been added to this listing';
                case 'ar':
                    return isSender ? 'تم إضافة رقم الشاصي لهذا الإعلان' : 'تم إضافة رقم الشاصي لهذا الإعلان';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForVIN.png",
        },
        slug: "ask_for_vin_s2b",
        hasButtonSeller: false,
        hasButtonBuyer: true,
        buttonTextSeller: '',
        buttonTextBuyer: 'ASK_FOR_VIN_S2B',
        action: (message) => {
            redirectToOpenSooq(message.pid);
        },
    },
    [SystemMessageTypes.ASK_FOR_LOCATION_S2B]: {
        type: 50,
        subType: 556,
        text: (lang, _username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? `I've added a map to this listing` : 'A map was added to this listing';
                case 'ar':
                    return isSender ? 'تم تحديد الخريطة لهذا الإعلان' : 'تم تحديد الخريطة لهذا الإعلان';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForVIN.png",
        },
        slug: "ask_for_location_s2b",
        hasButtonSeller: false,
        hasButtonBuyer: true,
        buttonTextSeller: '',
        buttonTextBuyer: 'ASK_FOR_LOCATION_S2B',
        action: (message) => {
            redirectToOpenSooq(message.pid);
        },
    },
    [SystemMessageTypes.ASK_FOR_VIDEO_S2B]: {
        type: 50,
        subType: 561,
        text: (lang, _username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? `I've added a video to this listing` : 'A video has been added to this listing';
                case 'ar':
                    return isSender ? 'تمت إضافة فيديو لهذا الإعلان' : 'تمت إضافة فيديو لهذا الإعلان';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForVideoChat.png",
        },
        slug: "ask_for_video_s2b",
        hasButtonSeller: false,
        hasButtonBuyer: true,
        buttonTextSeller: '',
        buttonTextBuyer: 'ASK_FOR_VIDEO_S2B',
        action: (message) => {
            redirectToOpenSooq(message.pid);
        },
    },
    [SystemMessageTypes.ASK_FOR_VIDEO]: {
        type: 50,
        subType: 511,
        text: (lang, username, isSender) => {
            switch (lang) {
                case 'en':
                    return isSender ? "I asked to be notified when a video is added to this listing" : `${username} want to be notified when a video is added to this listing`;
                case "ar":
                    return isSender ? "أريد أن اتلقى تنبيها اذا تمت إضافة فيديو لهذا الإعلان" : "أن يتلقى تنبيها اذا تمت إضافة فيديو لهذا الإعلان " + "\u200E" + username + "\u200E" + 'يريد';
            }
            return '';
        },
        rich: {
            icon: "/stickers/askForVideoChat.png",
        },
        slug: "ask_for_video",
        hasButtonSeller: true,
        hasButtonBuyer: false,
        buttonTextSeller: 'ASK_FOR_VIDEO',
        buttonTextBuyer: '',
        action: (message) => {
            const identifier = isDeviceMobile() ? 'postVideo' : 'reelSectionIdentifier';
            redirectToEditPost(identifier, message.pid);
        }
    },
};
